import { ThemeProvider } from '@material-ui/core/styles'
import React from 'react'
import ReactDOM from 'react-dom'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import ErrorBoundary from './components/error-boundary'
import { LinkedInProvider } from './components/LinkedInTooltip/provider'
import { TemplateProvider } from './components/template/provider'
import { TemplateCancellationProvider } from './components/template-cancellation/provider'
import { TemplateDeclarationProvider } from './components/template-declaration/provider'
import { TemplateProviSignProvider } from './components/template-provisign/provider'
import TypeForm from './components/TypeFormIntegration'
import { Navigation } from './navigation'
import theme from './utils/mui'
import './config'
import './style.css'

ReactDOM.render(
  <ErrorBoundary>
    <PostHogProvider client={posthog}>
      <ThemeProvider theme={theme}>
        <TemplateProvider>
          <TemplateProviSignProvider>
            <TemplateDeclarationProvider>
              <TemplateCancellationProvider>
                <LinkedInProvider>
                  <TypeForm />
                  <Navigation />
                </LinkedInProvider>
              </TemplateCancellationProvider>
            </TemplateDeclarationProvider>
          </TemplateProviSignProvider>
        </TemplateProvider>
      </ThemeProvider>
    </PostHogProvider>
  </ErrorBoundary>,
  document.getElementById('provi-root')
)
